import {useCallback, useEffect, useState} from 'react';

import {
  MessageFromParent,
  MessageFromParentType,
} from '@stripe-internal/support-conversations-controller';

import {devLog} from '../../../core/lib/util/dev';
import type {ParentMessageBus} from '../../../core/lib/parentMessageBus/ParentMessageBus';
import {useParentMessageBus} from '../../../core/hooks/appHooks';

export function useDocumentVisibilityForParentMessageBus({
  addListener,
  removeListener,
}: ParentMessageBus) {
  const [documentVisibility, setDocumentVisibility] =
    useState<DocumentVisibilityState>('visible');

  const handler = useCallback((message: MessageFromParent) => {
    if (message.type === MessageFromParentType.DocumentVisibilityChange) {
      devLog('Updating document visibility from parent', {
        documentVisibility: message.data.documentVisibility,
      });
      setDocumentVisibility(message.data.documentVisibility);
    }
  }, []);

  useEffect(() => {
    addListener(handler);
    return () => removeListener(handler);
  }, [addListener, handler, removeListener]);

  return documentVisibility;
}

export function useDocumentVisibility() {
  return useDocumentVisibilityForParentMessageBus(useParentMessageBus());
}
